import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle}</title>
                    <meta name="description" content="CarbonCodes specialize in the design and development of highly engaging and effective websites and apps. We’re a one-stop-company for creating digital products from idea to implementation." />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
